import { createUseStyles } from '@glu/theming';

import { ISideNavExtendedTheme } from './SideNav.types';

/* istanbul ignore next */
const styles = ({ nav, pageHeader: { heightNum }, zIndex }: ISideNavExtendedTheme) => ({
  nav: {
    '& ::-webkit-scrollbar': {
      display: 'none'
    },
    '& a': {
      color: nav?.color || '#ffffff',
      transition: 'all 100ms',
      '&:hover': {
        color: nav?.color || '#ffffff'
      }
    },

    '& div[role="dialog"] > div:before': {
      top: `${heightNum - 1}px`
    },

    // We need a fix in GLU, so we can target against specific element
    '& [data-qa="side-nav-panel"] > div:nth-child(1)': {
      height: heightNum,
      padding: [0.27 * heightNum, 0]
    },
    // (Firefox, Edge)
    '& [data-qa="side-nav-panel"] > div:nth-child(2)': {
      scrollbarWidth: 'none',
      '-ms-overflow-style': 'none'
    },
    zIndex: zIndex?.drawer,
    position: 'fixed',
    top: 0,
    '& .custom-link': {
      color: nav?.color || '#000000'
    },

    '& li': {
      '& button': {
        '& svg': {
          fill: nav?.color
        }
      }
    },
    '@media (max-width:350px)': {
      '& [class^="header"]': {
        justifyContent: ({ hasLiveEngage } = { hasLiveEngage: false }) =>
          hasLiveEngage ? 'flex-start' : 'space-between'
      },
      '& [class^="openLogo"]': {
        width: ({ hasLiveEngage } = { hasLiveEngage: false }) => (hasLiveEngage ? '55%' : '100%')
      }
    }
  },
  lastLogin: {
    fontSize: '12px',
    fontWeight: 'bold'
  },
  timestamp: {
    fontSize: '12px',
    fontWeight: 300
  }
});

export default createUseStyles<'nav', { hasLiveEngage: boolean }, ISideNavExtendedTheme>(styles);
